import { FormSection } from 'app/components/shared/FormSection'
import { SmartFileInputPreview } from 'app/components/shared/SmartFileInputPreview'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import { pdfInputTypes } from 'app/utils/fileUtils'
import { SponsorRequest } from 'EstraSponsor'
import React from 'react'
import styled, { useTheme } from 'styled-components'

type Props = {
  sponsorRequest: SponsorRequest
}

export const SponsorRequestFilesInnerForm = ({
  sponsorRequest,
}: Props): JSX.Element => {
  const theme = useTheme()

  return (
    <Container>
      <FormSection title='Documentazione'>
        <FormWrapper>
          <div>
            <Text variant='s20' mb={1} color={theme.color.primari.grigioEstra}>
              Allega la lettera di richiesta in carta intestata in formato PDF
              <RequiredSpan> * </RequiredSpan>
            </Text>
            <Text variant='s14' color={theme.color.primari.grigioEstra} mb={2}>
              La società richiedente deve inviare una lettera di richiesta in
              <BoldSpan> carta intestata</BoldSpan> in cui si specificano gli
              scopi dell&apos; attività, il luogo dove si terrà e l&apos;
              estensione temporale, il numero degli aderenti, il bacino di
              contatti, l&apos; attinenza ai valori Estra e le forme di
              visibilità che spettano al marchio a fronte del compenso
              richiesto. La lettera deve essere
              <BoldSpan> firmata e datata</BoldSpan>.{'\n'}
              <a
                href='https://res.cloudinary.com/estra/raw/upload/v1642180586/estra20dev/sponsor/template_richiesta_sponsor.docx'
                rel='noreferrer'
                target='_blank'
              >
                Clicca qui{' '}
              </a>
              per scaricare un documento di esempio.
            </Text>
            <SmartFileInputPreview
              name='sponsor_request_file'
              accept={pdfInputTypes.join(', ')}
              description='Formato immagine o PDF, dimensione massima 10 MB'
              previewUrl={sponsorRequest?.sponsor_request_pdf_url || undefined}
              labelRequired
            ></SmartFileInputPreview>
          </div>
          <div>
            <Text variant='s20' mb={1} color={theme.color.primari.grigioEstra}>
              Allega il documento di presentazione
            </Text>
            <SmartFileInputPreview
              name='presentation_file'
              accept={pdfInputTypes.join(', ')}
              description='Formato immagine o PDF, dimensione massima 10 MB'
              previewUrl={sponsorRequest?.presentation_url || undefined}
            ></SmartFileInputPreview>
          </div>
        </FormWrapper>
      </FormSection>
    </Container>
  )
}

const FormWrapper = styled.div`
  max-width: 700px;

  margin-top: 2rem;

  display: flex;
  flex-direction: column;
  gap: 4rem;
`

const RequiredSpan = styled.span`
  color: ${({ theme }) => theme.color.secondari.arancioneScuro};
`

const BoldSpan = styled.span`
  font-weight: bold;
`
